import React, { memo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from "highcharts/highcharts-more";
// import solidGauge from "highcharts/modules/solid-gauge";
import { useTheme } from '@mui/material';
import { getChartA11yOptions } from '../../../utils/highchartsAccessibility';

highchartsMore(Highcharts);
interface CustomGaugeChartProps {
    data: number
    title: string
}
const CustomGaugeChart = memo(function CustomGaugeChart(props: CustomGaugeChartProps): JSX.Element {
    const theme = useTheme();
    const a11yTitle = `${props?.title || 'Score'} gauge`;
    const a11y = getChartA11yOptions({
        altText: a11yTitle,
        description: `Gauge chart showing a ${props?.title || 'score'} value of ${props?.data} out of 100.`,
    });
    const options = {
        tooltip: {
            enabled: false
        },
        chart: {
            animation: true,
            // height: 300,
            style: {
                fontFamily: `${theme.typography.fontFamily}`,
                borderWidth: 0
            },
            backgroundColor: `${theme.palette.common.white}`,
            spacingBottom: 0,
            description: a11y.chartDescription,
        },
        title: a11y.title,
        accessibility: a11y.accessibility,
        pane: {
            center: ['50%', '50%'],
            size: '100%',
            startAngle: -150,
            endAngle: 150,
            background: [{
                borderWidth: 0,
                backgroundColor: theme.palette.common.white,
            }]
        },
        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            minorTickInterval: 'undefined',
            minorTickLength: 0,
            minorTickPosition: 'undefined',
            tickPixelInterval: 50,
            tickWidth: 3,
            tickPosition: 'undefined',
            tickLength: 0,
            labels: {
                step: 2,
                rotation: 'auto',
                useHTML: true,
                formatter: function (this: Highcharts.AxisLabelsFormatterContextObject): string {
                    const value = Number(this.value);
                    if (value % 10 === 0) {
                        return `<span style="fill:#EDF2F7; color:#EDF2F7;">${value}</span>`;
                    }
                    return `${value}`;
                }

            },
            title: {
                text: ''
            },
            plotBands: [{
                from: 0,
                to: 19,
                // color: theme.palette.primary[50],
                color: '#00E676',
                thickness: 12,
                // label: {
                //     text: 'Very Low',
                //     fontFamily: `${theme.typography.fontFamily}`,
                //     y: 50,
                //     x: 30
                // }
            }, {
                from: 20,
                to: 39,
                color: "#FFF176",
                // color: theme.palette.primary[100],
                thickness: 12
            }, {
                from: 40,
                to: 59,
                color: "#FDD835",
                thickness: 12
            },
            {
                from: 60,
                to: 79,
                color: "#FF6E40",
                thickness: 12
            },
            {
                from: 80,
                to: 100,
                // color: theme.palette.primary[500],
                color: "#DD2C00",
                thickness: 12,
                // label: {
                //     text: 'Very High',
                //     fontFamily: `${theme.typography.fontFamily}`,
                //     y: 50,
                //     x: -50
                // }
            }
            ]
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            series: {
                center: ['50%', '115%']
            }
        },
        series: [{
            type: 'gauge',
            data: [Math.min(100, props?.data)],
            dataLabels: {
                useHTML: true,
                align: 'center',
                formatter: function (this: any) {
                    return '<span style="color:grey;">' + 'Score' + '</span><br/>' +
                        '<span style="color:text.primary;font-weight:bold;font-size: 24px;">' + props?.data + '</span>'
                },
                borderWidth: 0
            },
            dial: {
                radius: '90%',
                backgroundColor: theme.palette.text.primary,
                baseWidth: 12,
                baseLength: '0%',
                rearLength: '0%',
                // Change the needle type to arrow
                arrowLength: 10,
                arrowWidth: 6,
                shape: 'arc',
                // Arrow color
            },
            pivot: {
                backgroundColor: theme.palette.text.primary,
            }
        },
        ]
    };
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            // containerProps={{ style: { height: '50%' } }}
            containerProps={{ style: { height: '100%', width: "100%" } }}
        />
    )
})
export default CustomGaugeChart
